import { useState } from "react";
import { CoinsTransferArea } from "./components/coin-transfer-area";
import { SalesHistory } from "./components/sales-history";

type Tab = "sale" | "history";

export const InfoTransfer = () => {
  const token = localStorage.getItem("@token");
  const [tab, setTab] = useState<Tab>("sale");

  if (!token) {
    return null;
  }

  const tabStyle = (active: boolean) => ({
    flex: 1,
    padding: "14px 8px",
    background: "transparent",
    border: "none",
    borderBottom: `3px solid ${active ? "#3f51b5" : "transparent"}`,
    color: active ? "#3f51b5" : "#777",
    fontSize: "15px",
    fontWeight: active ? ("bold" as const) : ("normal" as const),
    cursor: "pointer",
  });

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        background: "#f0f3fc",
        minHeight: "100vh",
      }}
    >
      {/* menu de abas no topo — Venda (card) | Histórico */}
      <div
        style={{
          display: "flex",
          background: "#fff",
          borderBottom: "1px solid #e6e6ef",
          position: "sticky",
          top: 0,
          zIndex: 1,
        }}
      >
        <button style={tabStyle(tab === "sale")} onClick={() => setTab("sale")}>
          Venda
        </button>
        <button
          style={tabStyle(tab === "history")}
          onClick={() => setTab("history")}
        >
          Histórico
        </button>
      </div>

      {tab === "sale" ? (
        <CoinsTransferArea />
      ) : (
        <div style={{ padding: "16px" }}>
          <SalesHistory />
        </div>
      )}
    </div>
  );
};
